<template>
  <div id="chart">
    <v-btn v-if="!bloquear_hist_faturamento && showChart" id="btn-ocultar-chart" icon @click="showChart = !showChart">
      <v-icon v-show="showChart === true">mdi-eye-off</v-icon>
    </v-btn>

    <content-blocked
      v-if="bloquear_hist_faturamento || !showChart"
      :bloquear_hist_faturamento="bloquear_hist_faturamento"
      @ver-conteudo="showChart = !showChart"
    />

    <div v-if="!bloquear_hist_faturamento" class="pb-1 height-full">
      <apexchart
        v-show="showChart"
        width="100%"
        height="100%"
        :options="options"
        :series="series"
      ></apexchart>
    </div>
  </div>
</template>

<script>
import DashboardAPI from "./../../api/dashboard";
import { mapGetters } from "vuex";
import { options } from "./charts/ChartMovimentacoesOptions";
import ContentBlocked from "../utils/ContentBlocked.vue";

export default {
  components: {ContentBlocked},
  data: () => ({
    options: options,
    series: [],
    valorMax: 0,
    showChart: true,
    bloquear_hist_faturamento: false
  }),
  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras",
    }),
    maxEscala() {
      return this.valorMax + this.valorMax / 3;
    },
    yaxis: function () {
      return {
        forceNiceScale: true,
        max: this.maxEscala,
        labels: {
          formatter: (val) => {
            return this.formatarValor(val, 0);
          },
        },
      };
    },
  },
  watch: {
    grupoCompra: function () {
      this.buscarDadosGrafico();
    },
  },
  created() {
    this.buscarDadosGrafico();
  },
  methods: {
    buscarDadosGrafico() {
      const headers = this.Helpers.getHeaderRequisicao();
      const comprador = this.$store.getters['usuario/getComprador'];

      const params = {
        grupo: this.grupoCompra,
        idcomprador: comprador.id ? comprador.id : 0
      }

      DashboardAPI.getDadosGraficoGrupo(headers, params)
        .then((response) => {
          const {token, movimentacoes, bloquear_hist_faturamento} = response.data;
          localStorage.setItem("token", token);

          const {
            compras,
            entradas,
            saidas,
            ref
          } = movimentacoes

          this.bloquear_hist_faturamento = bloquear_hist_faturamento;

          const dataTotal = compras.concat(entradas).concat(saidas);

          this.valorMax = dataTotal.reduce((a, b) => Math.max(a, b))

          this.options = {
            labels: ref,
            yaxis: this.yaxis
          }

          this.series = [
            {
              name: "Compras",
              type: "column",
              color: "rgba(4, 53, 84, 0.6)",
              data: compras,
            },
            {
              name: "Entradas",
              type: "column",
              color: "rgba(4, 53, 84, 1)",
              data: entradas,
            },
            {
              name: "Saídas",
              type: "column",
              color: "rgba(214, 14, 43,1)",
              data: saidas,
            },
          ];
        })
        .catch(() => {
          this.$store.dispatch("loading/habilitarLoading", false);
          // this.Helpers.logout();
        });
    },
    formatarValor: function (n, casasDecimais = 2) {
      const ranges = [
        { divider: 1e15, suffix: "P" },
        { divider: 1e12, suffix: "T" },
        { divider: 1e9, suffix: "G" },
        { divider: 1e6, suffix: "M" },
        { divider: 1e3, suffix: "k" },
        { divider: 1, suffix: " " },
      ];

      for (let i = 0; i < ranges.length; i++) {
        if (n >= ranges[i].divider) {
          if (ranges[i].divider === 1) {
            return (
              (Math.round(n) / ranges[i].divider).toString() + ranges[i].suffix
            );
          } else {
            return (
              (Math.round(n) / ranges[i].divider)
                .toFixed(casasDecimais)
                .toString() + ranges[i].suffix
            );
          }
        }
      }

      return 0;
    },
  },
};
</script>

<style scoped>
#btn-ocultar-chart {
  position: absolute;
  right: 5px;
  z-index: 1;
  margin-top: 3px;
}
.height-full {
  height: 100%;
}
</style>
